import { escape } from "lodash";
import { DynamicReferenceType } from "~/enums/dynamicReferenceType";
import Form from "../../../../formability/form_builder/models/form";
import WorkflowStep from "../../../../formability/form_builder/models/workflow/workflowStep";
import { Constructor } from "../../../../global/constructor";
import { IDynamicReferencedThing, IFormPaymentData, IFormPaymentsDynamicFieldSection } from "../../../interfaces/dynamicFieldsInterfaces";

export default function FormPaymentsDynamicFieldsHandlerMixin<TBase extends Constructor>(Base: TBase) {
  return class FormPaymentsDynamicFieldsHandler extends Base {
    form: Form;
    dynamicMessage: string;
    showDynamicMessage: boolean;

    paymentData(workflowStep: WorkflowStep): Array<IFormPaymentData> {
      return [
        {
          type: DynamicReferenceType.PaymentsTotalCost,
          id: `${workflowStep.id}_drt${DynamicReferenceType.PaymentsTotalCost}`,
          label: "Payment Total Amount"
        },
        {
          type: DynamicReferenceType.PaymentsType,
          id: `${workflowStep.id}_drt${DynamicReferenceType.PaymentsType}`,
          label: "Payment Type"
        },
        {
          type: DynamicReferenceType.PaymentsDate,
          id: `${workflowStep.id}_drt${DynamicReferenceType.PaymentsDate}`,
          label: "Payment Date"
        },
        {
          type: DynamicReferenceType.PaymentsReceiptNumber,
          id: `${workflowStep.id}_drt${DynamicReferenceType.PaymentsReceiptNumber}`,
          label: "Payment Receipt Number"
        },
        {
          type: DynamicReferenceType.PaymentsLineItem,
          fields: [
            { id: "name", label: "Line Item Name" },
            { id: "sku", label: "Line Item SKU" },
            { id: "description", label: "Line Item Description" },
            { id: "amount", label: "Line Item Amount" },
            { id: "type", label: "Line Item Type" }
          ]
        }
      ];
    }

    paymentDataSections(q: string): IFormPaymentsDynamicFieldSection[] {
      return this.form.workflowStepsArray
        .filter(ws => ws.isPaymentStep)
        .map(ws => {
          const paymentData = this.paymentData(ws).filter(d => {
            return d.fields
              ? d.fields.some(f => f.label.toLowerCase().match(q) !== null)
              : d.label.toLowerCase().match(q) !== null;
          });

          return {
            workflowStep: ws,
            paymentData,
            isOpen: paymentData.length > 0,
            select: this.selectPaymentData.bind(this)
          };
        });
    }

    protected selectPaymentData(
      paymentData: { id: string; label: string },
      type: DynamicReferenceType,
      workflowStep: WorkflowStep
    ): IDynamicReferencedThing {
      return {
        type: type,
        id: paymentData.id,
        label: paymentData.label,
        wsTitle: escape(workflowStep.titleOrDefault)
      };
    }
  };
}
